const DESIGN_DNA_PROCEED_EXACT = new Set([
  'yes',
  'yess',
  'proceed',
  'yes and proceed',
  'yes proceed',
  'yes, proceed',
  'yes, and proceed',
])

/** @param {string} trimmed */
function normalizeProceedPrompt(trimmed) {
  return trimmed.trim().replace(/\s+/g, ' ').toLowerCase()
}

/** @param {string} trimmed */
export function isDesignDnaProceedPrompt(trimmed) {
  const normalized = normalizeProceedPrompt(trimmed)
  if (DESIGN_DNA_PROCEED_EXACT.has(normalized)) return true
  return normalized.startsWith('yes') && normalized.includes('proceed')
}

/**
 * @param {unknown[]} priorMessages
 * @returns {boolean}
 */
export function threadAwaitingDesignDnaProceed(priorMessages) {
  if (!Array.isArray(priorMessages) || priorMessages.length === 0) return false

  for (let i = priorMessages.length - 1; i >= 0; i--) {
    const message = priorMessages[i]
    if (!message || typeof message !== 'object') continue

    const role = /** @type {{ role?: string }} */ (message).role
    if (role !== 'assistant') continue

    const assistant = /** @type {{
      designDnaAwaitingProceed?: boolean
      muiShowcaseBuildCompleted?: boolean
    }} */ (message)

    if (assistant.muiShowcaseBuildCompleted) return false
    return assistant.designDnaAwaitingProceed === true
  }

  return false
}
